import { FeedRow } from "../components/FeedRow";
import { card, C, FONT } from "../theme";
import type { ActivityFilter, FeedEntry } from "../types";

const FILTERS: { key: ActivityFilter; label: string }[] = [
  { key: "all", label: "All" },
  { key: "run", label: "Runs" },
  { key: "skip", label: "Holds" },
  { key: "alert", label: "Alerts" },
  { key: "sync", label: "Syncs" },
];

export function Activity({
  feed,
  filter,
  onFilter,
}: {
  feed: FeedEntry[];
  filter: ActivityFilter;
  onFilter: (f: ActivityFilter) => void;
}) {
  const rows = filter === "all" ? feed : feed.filter((e) => e.kind === filter);

  return (
    <div className="card-in">
      <p style={{ margin: "0 0 14px", fontSize: 12.5, color: C.textMid }}>
        Every run, hold, alert and weather sync.
      </p>

      <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 14 }}>
        {FILTERS.map((f) => {
          const on = filter === f.key;
          return (
            <button
              key={f.key}
              onClick={() => onFilter(f.key)}
              style={{
                fontFamily: FONT.sans,
                fontSize: 12.5,
                fontWeight: 500,
                padding: "7px 15px",
                borderRadius: 10,
                color: on ? C.onAccent : C.textMid,
                background: on ? C.ink : "transparent",
                border: `1px solid ${on ? C.ink : C.hairline}`,
                transition: "color .25s, background .25s, border-color .25s",
              }}
            >
              {f.label}
            </button>
          );
        })}
      </div>

      <div style={{ ...card, padding: "4px 18px" }}>
        {rows.length ? (
          rows.map((e) => <FeedRow key={e.id} e={e} />)
        ) : (
          <div
            style={{
              padding: "36px 0",
              textAlign: "center",
              fontSize: 13,
              color: C.textLow,
            }}
          >
            Nothing here yet.
          </div>
        )}
      </div>
    </div>
  );
}
